import { tv } from '@/common/theme/tv.config';

export const styles = {
  header: tv({
    base: 'min-h-2xl px-lg pb-md pt-xl sm:px-lg sm:py-lg',
    variants: {
      absolute: {
        true: 'absolute left-0 right-0',
      },
    },
  }),
  icon: 'shrink-0',
  shrink: 'shrink-[1]',
  content: tv({
    base: 'shrink grow',
    variants: {
      contentPadding: {
        none: 'p-0',
        lg: 'px-lg pb-lg pt-0 sm:px-lg sm:pb-lg sm:pt-0',
        xl: 'px-lg pb-lg pt-0 sm:px-xl sm:pb-xl sm:pt-0',
        '2xl': 'px-xl pb-xl pt-0 sm:px-2xl sm:pb-2xl sm:pt-0',
      },
      overflowY: {
        auto: '',
        none: 'overflow-y-visible',
      },
    },
  }),
  scrollContent: 'grow',
  close: 'absolute right-lg top-lg z-[1]',
  footer: tv({
    base: 'border-t border-[transparent] p-lg',
    variants: {
      border: {
        true: 'border-neutral20',
      },
    },
  }),
  handle:
    'absolute top-sm left-1/2 -translate-x-1/2 h-xs w-[6.4rem] bg-neutral40 rounded-md',
};
